/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityModel } from '../../models/facility-model';

export interface PractitionerClinicGroupIdPractitionerIdFacilitiesGet$Params {
  practitionerId: string;
  clinicGroupId: string;
}

export function practitionerClinicGroupIdPractitionerIdFacilitiesGet(http: HttpClient, rootUrl: string, params: PractitionerClinicGroupIdPractitionerIdFacilitiesGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<FacilityModel>>> {
  const rb = new RequestBuilder(rootUrl, practitionerClinicGroupIdPractitionerIdFacilitiesGet.PATH, 'get');
  if (params) {
    rb.path('practitionerId', params.practitionerId, {});
    rb.path('clinicGroupId', params.clinicGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<FacilityModel>>;
    })
  );
}

practitionerClinicGroupIdPractitionerIdFacilitiesGet.PATH = '/Practitioner/{clinicGroupId}/{practitionerId}/Facilities';
